import { useState, useEffect, useReducer } from "react";
import NurtureCampaignInitComp from "./NurtureCampaignInitComp/NurtureCampaignInitComp";
import "./NurtureCampaignContact/NurtureCampaignContactSearch.css";
import {
  addContactsToCampaign,
  changeCampaignDate,
  fetchOutlookToken,
  getCampaignDetailsPerContact,
  previewCampaignDetails,
  userClientData,
} from "../../../../../services/iqApiV2";
import { useUser } from "../../../../../context/UserContext";
import { findContactCardData } from "../../../../../store/features/sagas/opportunities/contactCardSaga";
import { useParams } from "react-router-dom";
import AutoNurtureHelperCard from "./AutoNurtureHelperCard";
import NurtureCampaignEmailReachOutV2 from "./NurtureCampaignEmailReachOut/NurtureCampaignEmailReachOutV2";
import {
  parseContact,
} from "../../../../../utilities/uiUtils";
import GeneratingLoader from "../../../genericComponents/uiElements/GeneratingLoader";
import { IQ_API_V2_BASE_URL } from "../../../../../config/apiConfig";
import { Button } from "react-bootstrap";
import * as FeatherIcon from "react-feather";
import WarningForNurture from "./WarningForNurture";
import NurtureCampaignContactMinimal from "./NurtureCampaignContact/NurtureCampaignContactMinimal";
import { formatDateToYMD } from "../../../../../utilities/dateUtils";
import DynamicAlertDialog from "../../../genericComponents/uiElements/DynamicAlertDialog";
import UpdateNurtureDate from "./UpdateNurtureDate";
import DynamicStepper from "../../../genericComponents/uiElements/DynamicStepper";
import WarningForNurtureGate from "./WarningForNurtureGate";

const STEP_IDS = {
  CAMPAIGN_INIT: "CAMPAIGN_INIT",
  CONTACT: "CONTACT",
  EMAIL_REACHOUT: "EMAIL_REACHOUT",
  FINAL_REVIEW: "FINAL_REVIEW",
};
const initialStepState = {
  [STEP_IDS.CAMPAIGN_INIT]: false,
  [STEP_IDS.CONTACT]: false,
  [STEP_IDS.EMAIL_REACHOUT]: false,
  [STEP_IDS.FINAL_REVIEW]: false,
};

function stepReducer(state, action) {
  switch (action.type) {
    case "MARK_COMPLETED":
      return { ...state, [action.payload]: true };
    case "RESET_STEP":
      return { ...state, [action.payload]: false };
    default:
      return state;
  }
}

const MoveToAutoNurture = ({ currOpp, setShowMoreModalForAn }) => {
  const [completedSteps, dispatch] = useReducer(stepReducer, initialStepState);
  const [searchHist,setSearchHist]=useState({})
  const [compLoading,setCompLoading]=useState(true);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [currentCampDetails, setCurrentCampDetails] = useState({});
  const [domain, setDomain] = useState("");
  const [emails, setEmails] = useState([]);
  const { user } = useUser();
  const [isCalendarConnected, setIsCalendarDataConnected] = useState(false);
  const { clientName, accountId, accountName } = useParams();


    const handleOutlookLogin = () => {
    const pageAfterLoginUrl = window.location.href;

    const afterLoginPageParams = { clientName, accountId, accountName };
    localStorage.removeItem("afterLoginPageParams");
    localStorage.setItem(
      "afterLoginPageParams",
      JSON.stringify(afterLoginPageParams)
    );
    localStorage.setItem("pageAfterLoginUrl", pageAfterLoginUrl);

    const loginWindow = window.open(
      IQ_API_V2_BASE_URL + "/outlook/login",
      "OutlookLogin",
      "width=600,height=500"
    );

    // 🔁 Polling to detect window close
    const checkPopupClosed = setInterval(() => {
      if (loginWindow.closed) {
        clearInterval(checkPopupClosed);
        window.location.reload(); // 🔄 Reload the current page
      }
    }, 500);
  };
  

  const postActionForNurture = async (campaignID) => {
    try {
      const resp = await findContactCardData(
        currOpp?.opportunity_id,
        user?.id,
        true
      );
      const parsedData = resp?.map(parseContact);
      setSelectedContacts(parsedData);
      dispatch({ type: "MARK_COMPLETED", payload: STEP_IDS.CAMPAIGN_INIT });
      if (parsedData?.length) {
        const searchList = {
          domain: domain,
          page: 1,
          per_page: 50,
          currentStepId: STEP_IDS.CAMPAIGN_INIT,
        };
        await addContactsToCampaign(
          campaignID,
          parsedData ?? [],
          { searchList }
        );
      }
      setCurrentStepIndex((prev) => prev + 1);
    } catch (error) {
      console.error(error);
    }
  };


useEffect(() => {
  setCompLoading(true);
  const fetchData = async () => {
    try {
      const currentRole = user?.role_key || "CLIENT";
      const data = await userClientData(user?.id, clientName, currentRole);
      const campaignMeta = await getCampaignDetailsPerContact(
        "MAXIMIZE_PIPE",
        user?.id,
        null,
        currOpp?.opportunity_id
      );
      const campaignId = campaignMeta?.[0]?._id;
      

      if (campaignId) {
        const campaignDetails = await previewCampaignDetails(campaignId);
        const curCampDetail = campaignDetails?.campaign?.[0];
        const campaignContacts = campaignDetails?.contacts[0]?.map(parseContact);
        const templatehist = campaignDetails?.templates?.[0];
        const finalTick = curCampDetail?.active_status;
        const lastStep = campaignDetails?.campaign?.[0]?.search_list?.[0]?.currentStepId
        console.log("campaignDetails",campaignDetails);


        if ([STEP_IDS.CAMPAIGN_INIT, STEP_IDS.CONTACT].includes(lastStep)) {
             dispatch({ type: "MARK_COMPLETED", payload: STEP_IDS.CAMPAIGN_INIT });
             setCurrentStepIndex(0);

          if (lastStep === STEP_IDS.CONTACT) {
             dispatch({ type: "MARK_COMPLETED", payload: STEP_IDS.CONTACT });
             setCurrentStepIndex(1);
          }
        }

        if (finalTick === 1) {
          dispatch({
            type: "MARK_COMPLETED",
            payload: STEP_IDS.EMAIL_REACHOUT,
          });
           setCurrentStepIndex(2);
        }

        const domainValue = campaignDetails?.campaign?.[0]?.search_list?.[0]?.domain;

        if (Array.isArray(domainValue)) {
          setDomain(domainValue[0]);
        } else if (typeof domainValue === "string") {
          setDomain(domainValue);
        } else {
          setDomain(""); // or keep undefined / fallback
        }
        setSelectedContacts(campaignContacts);
        setSearchHist(curCampDetail?.search_list?.[0]);
        setCurrentCampDetails({
          campaignName: currOpp?.opportunity_name,
          emailGenerationCount:curCampDetail?.email_generation_count,
          campaignContext: currOpp?.opportunity_description,
          startDate: formatDateToYMD(new Date(curCampDetail?.start_date||null)),
          products: curCampDetail?.products,
          daysFrequency: 3,
          account: accountName,
          opportunityId: curCampDetail?.opportunity_id,
          campaignId: curCampDetail?._id,
          campActive:curCampDetail?.active_status,
          lastStep:lastStep
        });
        
        // since i dont know what is the last step i perfomed . need a flag in backend
        // setCurrentStepIndex(campaignContacts?.length > 0 ? 2:1 );
        setCompLoading(false); // ✅ here
        return;
      }

      const envProducts = data?.products || [];
      const productsFormatted = Array.isArray(currOpp?.mapped_products)
        ? currOpp?.mapped_products.map((item) => {
            const matched = envProducts.find(
              (p) => p?.name?.toLowerCase().trim() === item?.toLowerCase().trim()
            );
            return {
              name: matched?.name || item,
              description: matched?.description || "",
            };
          })
        : [];

      setCurrentCampDetails((prev) => ({
        ...prev,
        campaignName: currOpp?.opportunity_name,
        emailGenerationCount:3,
        campaignContext: currOpp?.opportunity_description,
        startDate: null,
        products: productsFormatted,
        daysFrequency: 3,
        account: accountName,
        opportunityId: currOpp?.opportunity_id,
      }));
      
      setCompLoading(false); // ✅ also here
    } catch (error) {
      console.error(error);
      setCompLoading(false);
    }
  };

  fetchData();
  
}, [currOpp?.opportunity_id]);




  useEffect(() => {
    const getOutlookToken = async () => {
      if (user?.id) {
        const is_connected = await fetchOutlookToken(user?.id);
        setIsCalendarDataConnected(is_connected);
        // setIsCalendarDataLoading(true)
        setTimeout(() => {
          //  setIsCalendarDataLoading(false)
        }, 30000); // wait for 30 seconds
      }
    };
    getOutlookToken();
  }, [user?.id]);
  const campaignStartDate = currentCampDetails?.startDate ? formatDateToYMD(new Date(currentCampDetails?.startDate)) :formatDateToYMD(new Date()) ;
  const today = formatDateToYMD(new Date());

  const [productsList, setProducts] = useState([]);
  const stepsConfig = [
    {
      id: STEP_IDS.CAMPAIGN_INIT,
      title: "Setup",
      component: (
        <div>
          <WarningForNurture accountName={accountName} clientName={clientName} oppId={currOpp?.opportunity_id}/>
          <AutoNurtureHelperCard />
          

          <NurtureCampaignInitComp
            stepId={STEP_IDS.CAMPAIGN_INIT}
            setCurrentCampDetails={setCurrentCampDetails}
            setCurrentStepIndex={setCurrentStepIndex}
            currentCampDetails={currentCampDetails}
            domain={domain}
            setDomain={setDomain}
            newFlow={true}
            selectedCompanies={accountName}
            movingToAN={true}
            setShowMoreModalForAn={() => {}}
            movingToANPostAction={postActionForNurture}
            noOppRefresh={true}
            productsList={productsList}
            setProducts={setProducts}
            pageType="MAXIMIZE_PIPE"
          />
        </div>
      ),
    },
    {
          id: STEP_IDS.CONTACT,
          title: "Select Contacts",
          component: (
            <NurtureCampaignContactMinimal
              stepDispatch={dispatch}
              stepId={STEP_IDS.CONTACT}
              currentCampDetails={currentCampDetails}
              setCurrentStepIndex={setCurrentStepIndex}
              searchHist={searchHist}
              setSearchHist={setSearchHist}
              selectedContacts={selectedContacts}
              setSelectedContacts={setSelectedContacts}
              domain={domain}
              skipSearch={false}
            />
          ),
    },
    {
      id: STEP_IDS.EMAIL_REACHOUT,
      title: "Generate Emails",
      component: (
        <NurtureCampaignEmailReachOutV2
          stepDispatch={dispatch}
          stepId={STEP_IDS.EMAIL_REACHOUT}
          currentCampDetails={currentCampDetails}
          setCurrentStepIndex={setCurrentStepIndex}
          emails={emails}
          setEmails={setEmails}
          selectedContacts={selectedContacts}
          setSelectedContacts={setSelectedContacts}
          sideCardCloseFunc={setShowMoreModalForAn}
          skipReview={true}
        />
      ),
    },
  ];
  if (!compLoading &&!isCalendarConnected) {
    return <div  style={{width:"99%"}}className="connect_calendar_card mb-3 m-2 ">
          <div className="row">
            <div className="col-md-6">
              <div className="connect_calendar_block">
                <div className="connect_calendar_icon">
                  <FeatherIcon.Mail className="calendar_fa" />
                </div>
                <div className="connect_para_block">
                  <p className="connect_calendar_head">
                    Connect your calendar{" "}
                  </p>
                  <p className="connect_para">
                    Connect with your Outlook to automate Campaign
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <span className="connect_calendar_btnblock">
                <Button
                  variant="primary"
                  type="submit"
                  className="pull-right connect_calendar_btn"
                  onClick={() => handleOutlookLogin()}
                >
                  {" "}
                  Connect your calendar{" "}
                </Button>
              </span>
            </div>
          </div>
        </div>
  }

  if (compLoading) {
      return <div  style={{width:"100%",height:"30vh",display:"flex",justifyContent:"center",alignItems:"center"}}><GeneratingLoader/></div>
  }


  const childrenComp = <>
  
    
       <DynamicStepper
          stepsConfig={stepsConfig}
          completedSteps={completedSteps}
          currentStepIndex={currentStepIndex}
          setCurrentStepIndex={setCurrentStepIndex}
          // compInitiating={compInitiating}
          campaignStartDate={campaignStartDate}
          today={today}
          campActive={currentCampDetails?.campActive}
        />

      {campaignStartDate < today && currentCampDetails?.campActive==0 && (
        <DynamicAlertDialog
          title="Date Alert"
          message={
            <>
              <UpdateNurtureDate
                handleDateUpdatePostActions={async (newDate) => {
                  if (currentCampDetails?.campaignId) {
                    try {
                      await changeCampaignDate(
                        newDate,
                        currentCampDetails?.campaignId,
                        user?.id
                      );
                    } catch (error) {
                      console.error("changeCampaignDate error", error);
                    }finally{
                    setCurrentCampDetails((prev) => ({
                      ...prev,
                      startDate: formatDateToYMD(new Date(newDate)),
                    }));
                    }


                  }
                }}
              />
            </>
          }
          type="info"
          autoShow={true}
        />
      )}
    </>
  return (
 <WarningForNurtureGate accountName={accountName} clientName={clientName} oppId={currOpp?.opportunity_id} children={childrenComp}/>
  );
};

export default MoveToAutoNurture;
